import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Tie } from '../../_shared/models/tie.model';
import { User } from '../../_shared/models/user.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { Match } from '../../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-participant-name',
    templateUrl: './participant-name.component.html',
    styleUrls: ['./participant-name.component.scss']
})
export class ParticipantNameComponent {
    @Input() match: Match;
    @Input() tie: Tie;
    @Input() sideNumber: number;
    @Input() participantColor: string;
    @Input() isStreamView: boolean;

    constructor(
        private bhs: BoardHelpService
    ) { }

    getParticipantName(person: User) {
        if (person) {
            return `${person.last_name?.toUpperCase()}, ${person.first_name}`;
        } else {
            if (this.tie) {
                return `${this.getTeamName()} ${this.match.collectionPosition}`;
            } else {
                return `Player ${this.sideNumber}`;
            }
        }
    }

    getServerClass(playerNumber) {
        let applyClass = false;
        if (this.match.matchStatus !== 'TBP') {
            if (this.match.winningSide && this.match.winningSide === this.sideNumber) {
                applyClass = true;
            } else {
                if (this.match.sets.length && this.match.score.server?.sideNumber === this.sideNumber) {
                    if (!this.match.score.server.playerNumber || this.match.score.server.playerNumber === playerNumber) {
                        applyClass = true;
                    }
                }
            }
        }

        return { 'server': applyClass };
    }

    getColor(playerNumber) {
        let applyColor = false;
        if (this.match.matchStatus !== 'TBP') {
            if (this.match.winningSide && this.match.winningSide === this.sideNumber) {
                applyColor = true;
            } else {
                if (!this.match.winningSide && this.match.score?.sets?.length && this.match.score?.server?.sideNumber === this.sideNumber) {
                    if (!this.match.score?.server.playerNumber || this.match.score?.server.playerNumber === playerNumber) {
                        applyColor = true;
                    }
                }
            }
        }

        return applyColor ? this.participantColor : null;
    }


    getTeamName() {
        if (this.tie?.sides[this.sideNumber - 1]?.team) {
            return this.tie?.sides[this.sideNumber - 1]?.team.abbreviation;
        }

        return null;
    }


}
